import React, { useState } from "react";
import TableHeader from "../Assets/TableHeader";
import TableBody from "../Assets/TableBody";
import {  User } from "../Types/Types";
import LoadingCircle from "../Assets/LoadingCirlce";
import TableFooterPagination from "../Assets/TableFooterPagination";
import ErrorComponent from "../Assets/ErrorComponent";

interface AdminUserTableProps {
    users: User[];
    loading: boolean;
    error: string | null;
onSortChange: (field: string, order: 'asc' | 'desc') => void;
    onDelete: (id: string) => void;
    onEdit: (career: User) => void;
    lang: string
}



const AdminUserTable: React.FC<AdminUserTableProps> = ({
    users,
    loading,
    error,
    onSortChange,
    onDelete,
    onEdit,
    lang
}) => {
    const [sortBy, setSortBy] = useState<string>("createdAt");
    const [sortOrder, setSortOrder] = useState<string>("desc");
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [rowsPerPage, setRowsPerPage] = useState<number>(5);
    const totalPages = Math.ceil(users.length / rowsPerPage);

    const handleSort = (column: string) => {
        const newOrder = sortBy === column && sortOrder === "asc" ? "desc" : "asc";
        setSortBy(column);
        setSortOrder(newOrder);
        onSortChange(column, newOrder);
    };

    const handlePageChange = (newPage: number) => {
        if (newPage > 0 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const handleRowsPerPageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newRows = parseInt(e.target.value, 10);
        setRowsPerPage(newRows);
        setCurrentPage(1); 
    };



    if (loading) return <LoadingCircle />;
    if (error) return <ErrorComponent message={error} />

    return (
        <div className="overflow-x-auto bg-white shadow-md rounded-lg">
            <table className="min-w-full table-auto">
                <TableHeader
                    data={users}
                    handleSort={handleSort}
                    sortBy={sortBy}
                    sortOrder={sortOrder}
                />

                <TableBody
                    data={users}
                    onDelete={(id: string) => onDelete(id)}
                    onEdit={onEdit}
                    lang={lang}
                    editable={false}
                />
            </table>
            <TableFooterPagination
                currentPage={currentPage}
                totalPages={totalPages}
                rowsPerPage={rowsPerPage}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
            />
        </div>
    );
};

export default AdminUserTable;
